import { LoadingOutlined } from '@ant-design/icons';
import { cx } from '@emotion/css';
import styled from '@emotion/styled';
import SafeImage from 'components/SafeImage';
import useRevokeObjectURL from 'hooks/useRevokeObjectURL';

export interface ImageMessageProps {
  className?: string;
  src: string;
  uploading?: boolean;
  width?: number | string;
  imgSize?: {
    width: number;
    height: number;
  };
  localUpload?: boolean;
  lazyScrollContainer?: Element | null;
  onLoad?: () => void;
}

const Mask = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
`;

const ImageMessage = (props: ImageMessageProps) => {
  const {
    src,
    className,
    uploading = false,
    width = 200,
    imgSize,
    lazyScrollContainer,
    onLoad,
  } = props;
  useRevokeObjectURL(src);

  return (
    <div className={cx(['relative', className])} onClick={(e) => e?.stopPropagation()}>
      <SafeImage
        preview
        src={src}
        width={width}
        imgSize={imgSize}
        target={lazyScrollContainer}
        onLoad={onLoad}
      />
      {uploading && (
        <Mask>
          <LoadingOutlined />
        </Mask>
      )}
    </div>
  );
};
export default ImageMessage;
